import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export const newsCreatorTypeEnum = {
  ADMINISTRATOR: { label: "Info Pharm-UPP", color: "" },
  PRESIDENT_UPP: { label: "Info Président", color: "primary.main" },
  LABORATORY_CONTACT: { label: "Info Labo", color: "#087ca1" },
} as const satisfies ReferentialEnum<{ color: string }>
export const newsCreatorTypeReferential =
  referentialEnumToReferentialCodeList(newsCreatorTypeEnum)
export type NewsCreatorTypeName = keyof typeof newsCreatorTypeEnum
